import cn from "classnames";
import React, { useContext } from "react";
import ScrollerContext from "../context";
import css from "./index.module.scss";

export type ScrollingContainerProps = {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  sideHeader?: boolean;
};

const ScrollingContainer = React.forwardRef<
HTMLOListElement,
ScrollingContainerProps>(({
  children,
  className,
  sideHeader,
}, ref) => {
  const { fullPageStretch, hasItemOverflow, gotoNext, gotoPrev } = useContext(ScrollerContext);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowRight") {
      gotoNext();
    }
    if (e.key === "ArrowLeft") {
      gotoPrev();
    }
  };

  return (
    <div
      className={cn(css["hbd-scroller__wrapper"], {
        [css["hbd-scroller__wrapper--stretch"]]: fullPageStretch && !sideHeader,
        [css["hbd-scroller__wrapper--side_header"]]: sideHeader,
      })}
    >
      <ol
        ref={ref}
        tabIndex={hasItemOverflow ? 0 : -1}
        onKeyDown={handleKeyDown}
        className={cn(css["hbd-scroller__container"], {
          [css["hbd-scroller__container--center"]]: !hasItemOverflow,
          [css["hbd-scroller__container--smooth"]]: true,
        }, className)}
      >
        {children}
      </ol>
    </div>
  );
});

ScrollingContainer.displayName = "ScrollingContainer";

export default ScrollingContainer;
